<script>
  import { style, present, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- START Blogs w/ 3 rows w/ image on left & title, text, author on end-->
<section style="{style(block)}">
  <div class="container">
    {#each blocklist(block, 'list') as item}
    <div id="{item.slug}" class="row">
      <div class="col-md-12 ms-auto me-auto">
        <div class="card card-plain card-blog mt-5">
          <div class="row">
            {#if present(item, 'picture')}
            <div class="col-md-4">
              <div class="card card-background card-background-mask-primary mb-2" style="height: 400px;">
                <div class="full-background" style="background-image: url('{image(item, 'picture', [500, 500])}')"></div>
                 <div class="card-body pt-5 text-center">
                   <div class="icon icon-lg up mb-5">
                     <img src="{image(item, 'icon', [null, 100])}" height="80" alt="">
                   </div>
                   <h3 class="text-white up mb-0">{text(item, 'pictureTitle')}</h3>
                </div>
              </div>
            </div>
            {/if}
            <div class="col-md-7 my-auto ms-md-3 mt-md-auto mt-4">
              <h3>
                {text(item, 'headline')}
              </h3>
              <p>
                {@html richtext(item, 'body')}
              </p>
      	      <!-- <div class="author"> -->
      	        <!--   <img src="../../assets/img/team-1.jpg" alt="..." class="avatar avatar-sm shadow me-2"> -->
      	        <!--   <p class="my-auto">Katie Roof</p> -->
      	        <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    {/each}
  </div>
</section>
<!-- END Blogs w/ 3 rows w/ image on left & title, text, author on end-->
